import React from "react";
import { cn } from "../../lib/src/utils/shorthands";
import * as scss from "./docs-table.scss";

type DocsTableProps = {
	children: React.ReactNode;
	border?: "full" | "top";
	standalone?: boolean;
	withImage?: boolean;
};

export const DocsTable = ({
	children,
	border = "full",
	standalone = true,
	withImage,
}: DocsTableProps): JSX.Element => (
	<div
		className={cn(
			scss.container,
			scss[border],
			standalone && scss.standAlone,
			withImage && scss.withImage
		)}
	>
		<table className={scss.table}>{children}</table>
	</div>
);
DocsTable.highlightTrClass = scss.highlight;
